<script>
	export let data;

	import { isMobile, isNewDataChanged } from "../../../../stores/variables";

	import { quill } from "svelte-quill";
	import { onMount } from "svelte";

	if (data) {
		if (!data.newData) data.newData = [];

		onMount(() => {
			let t = document.querySelector(".ql-editor");
			if (data.newData) {
				if (data.newData[data.field_name]) {
					if (t) {
						let temp = data.newData[data.field_name];
						temp = temp.replace(/\s*<\/li>\s*<li>/, "</li><li>");
						temp = temp.replace(/<ul>\s*<li>\s*/, "<ul><li>");
						temp = temp.replace(/<\/li>\s*<\/ul>\s*/, "</li></ul>");
						temp = temp.replace(/<ol>\s*<li>\s*/, "<ol><li>");
						temp = temp.replace(/<\/li>\s*<\/ol>\s*/, "</li></ol>");
						content.html = temp;
						t.innerHTML = content.html;
					}
				}
			}
		});
	}

	let options = {
		modules: {
			toolbar: [
				[{ header: 1 }, { header: 2 }, "blockquote"],
				["bold", "italic", "underline", "strike"],
				[{ list: "ordered" }, { list: "bullet" }],
				[{ align: [] }],
				["clean"],
			],
		},
		placeholder: "",
		theme: "snow",
	};

	let content = { html: "", text: "" };
	let mount = 0;

	$: if (content.html) {
		if (mount < 2) {
			mount++;
		} else {
			$isNewDataChanged = true;
		}
	}
</script>

<svelte:head>
	<link href="//cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet" />
</svelte:head>

{#if data}
	{#if data.name}
		<h3>{data.name}</h3>
	{/if}

	<div class="description">
		<div class="textarea__wrap">
			<p
				class="editor {$isMobile ? 'mobile' : 'not_mobile'}"
				id="editor-container"
				use:quill={options}
				on:text-change={(e) => {
					content = e.detail;
					data.newData[data.field_name] = content.html;
				}}
			/>

			<span />

			<span class={data.newData[data.field_name] ? "active" : ""}
				>{data.description}</span
			>
		</div>
		<span
			>Мы оставляем за собой право изменить описание, исправить ошибки,
			убрать грубую и нечестную рекламу, сравнение с конкурентами</span
		>
	</div>
{/if}

<style lang="scss">
	.description {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);

		> span {
			color: var(--text-gray-3);
			font-size: 13px;
			line-height: 20px;
			margin: 16px 0 0 0;
		}

		> div {
			min-height: 100px;
		}
	}
	.textarea__wrap {
		flex-direction: column;
	}
	.editor {
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
	}
</style>
